// Pure derivations for the accuracy dashboard (feature 11): every number shown
// comes from the backend aggregates — nothing here invents data. A metric with
// no data yet is `null` (rendered "–"), never 0.

export function pct(rate) {
  return rate === null || rate === undefined ? null : Math.round(rate * 1000) / 10;
}

export function formatPct(rate) {
  const value = pct(rate);
  return value === null ? "–" : `${value}%`;
}

// Only runs of the same dataset as the newest one are comparable: a custom
// upload ("custom") or a case subset ("golden[c1,c2]") is a different test,
// so it must never become the trend's next point or "the previous run".
export function comparableRuns(runs) {
  const list = runs || [];
  if (!list.length) return [];
  const dataset = list[0].dataset;
  return dataset === undefined ? list : list.filter((run) => run.dataset === dataset);
}

// `runs` arrive newest-first (cursor order); the trend wants oldest-first.
export function accuracyTrend(runs) {
  return [...comparableRuns(runs)].reverse().map((run) => ({
    id: run.id,
    label: run.label || String(run.id),
    createdAt: run.created_at,
    passRate: run.pass_rate,
  }));
}

export function accuracyDelta(runs) {
  const comparable = comparableRuns(runs);
  if (comparable.length < 2) return null;
  return comparable[0].pass_rate - comparable[1].pass_rate;
}

// Per-day totals across workspaces from usage `daily` rows.
export function dailyQueries(daily) {
  const byDay = new Map();
  (daily || []).forEach((row) => byDay.set(row.day, (byDay.get(row.day) || 0) + row.queries));
  return [...byDay.entries()].sort(([a], [b]) => a.localeCompare(b)).map(([day, queries]) => ({ day, queries }));
}

export function deriveKpis({ usage, feedback, runs }) {
  const queries = usage?.totals?.queries ?? null;
  const errors = usage?.totals?.errors ?? 0;
  return {
    accuracy: runs && runs.length ? runs[0].pass_rate : null,
    accuracyDelta: accuracyDelta(runs),
    helpfulRate: feedback?.helpful_rate ?? null,
    queries,
    errorRate: queries ? errors / queries : null,
    pendingReview: feedback?.totals?.pending_review ?? null,
  };
}
